// Titre d'une zone de la carte. Avec `onglet` et `ouvrir`, le titre est un
// bouton qui ouvre cette section dans le panneau de détail.
const TitreZone = ({ icone, onglet, ouvrir, children }) => (
  <h4 className="la-zone__titre">
    {onglet && ouvrir ? (
      <button type="button" className="la-zone__lien" data-la-onglet={onglet} onClick={() => ouvrir(onglet)}>
        <i className={`fa ${icone}`} aria-hidden="true" />
        {children}
        <i className="fa fa-chevron-right la-zone__chevron" aria-hidden="true" />
      </button>
    ) : (
      <>
        <i className={`fa ${icone}`} aria-hidden="true" />
        {children}
      </>
    )}
  </h4>
);

export default TitreZone;
